import { ActionConstants } from '../constants';

export const addUser = user => ({ type: ActionConstants.ADD_USER, payload: user });

export const deleteUser = user => ({type: ActionConstants.DELETE_USER, payload: {}});

export const changeTheme = theme => ({ type: ActionConstants.CHANGE_THEME, payload: theme });

export const addReceiver = user => ({ type: ActionConstants.ADD_RECEIVER, payload: user });

export const deleteReceiver = user => ({ type: ActionConstants.DELETE_RECEIVER, payload: {}});


// WEBPACK FOOTER //
// ./src/actions/index.js